export const onTableResizeStart = (state) => {
    return { ...state, isTableResizing: true };
};
export const onTableResizeEnd = (state, action) => {
    return {
        ...state,
        isTableResizing: false,
        columnResizing: {
            ...state.columnResizing,
            columnWidths: {
                ...action.columnWidths,
            },
        },
    };
};
